import LoadingElement from '../Common/LoadingElement';

const TableElement = ({ data, columns, loading, render }) => {
  return (
    <div className="table-responsive">
      {loading ? <LoadingElement height='500px' /> : data.length > 0 ? <table className="text-center">
        <thead>
          <tr className="mb-2">
            <th>SL No.</th>
            {columns.map((col, index) => (
              <th key={index}>{col?.name || col}</th>
            ))}
          </tr>
        </thead>
        <tbody>{data.map((row, rowIndex) => render(row, rowIndex))}</tbody>
      </table> : <div className="no-data d-flex justify-content-center align-items-center">
        <p>No data available</p>
        </div>}
    </div>
  );
};

export default TableElement;

export const EditableTHead = ({ isEditable, item, action}) => {
  return <th scope="col" className="text-start"
    contentEditable={isEditable}
    suppressContentEditableWarning={true}
    onClick={(e) => {
      // Only clear if contentEditable is true for this specific th
      if (e.currentTarget.contentEditable === 'true') {
        e.currentTarget.textContent = '';
      }
    }} onInput={action}>{item}</th>
}